module.exports = __webpack_public_path__ + "static/media/haitiflag.739c4d2a.png";